import { css } from "@emotion/react"
import emotionNormalize from "emotion-normalize"
import { fontImports, Montserrat, Fira } from "./fonts"
import { lightGrey, darkGrey, offWhite } from "./colors"

export const baseCss = css`
  ${fontImports}
  ${emotionNormalize}
  
  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
    @media screen and (max-width: 1000px) {
      font-size: 58.5%;
    }
    @media screen and (max-width: 800px) {
      font-size: 54.6%;
    }
    @media screen and (max-width: 600px) {
      font-size: 50.5%;
    }
    @media screen and (max-width: 400px) {
      font-size: 46.5%;
    }
  }

  body {
    ${Fira}
    background-color: ${lightGrey};
    color: ${darkGrey};
    margin: 0;
    padding: 0;
    font-size: 1.8rem;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    ${Montserrat}
    font-weight: 700;
    margin: 0;
    margin-bottom: 2rem;
    color: ${darkGrey};
    line-height: 1.2;
  }

  h1 { font-size: 4.4rem; }
  h2 { font-size: 3.5rem; }
  h3 { font-size: 2.8rem; }
  h4 { font-size: 2.2rem; }
  h5 { font-size: 1.8rem; }
  h6 { font-size: 1.6rem; }

  * {
    box-sizing: border-box;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
  }

  a {
    transition: all 0.2s ease-in-out;
    color: inherit;
    text-decoration: none;
  }

  p {
    margin-bottom: 1.8rem;
  }

  ul, ol {
    margin-bottom: 1.8rem;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.8rem;
  }
`
